// extracted by mini-css-extract-plugin
export default {"selectionWidth":"_7c4eebdf"};